'use client'

import { create } from 'zustand'

/** Chrome's `beforeinstallprompt` event — not yet in lib.dom.d.ts. */
export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>
}

interface PwaInstallState {
  deferredPrompt: BeforeInstallPromptEvent | null
  isInstalled: boolean
  setDeferredPrompt: (event: BeforeInstallPromptEvent | null) => void
  setInstalled: () => void
  clearDeferredPrompt: () => void
}

export const usePwaInstallStore = create<PwaInstallState>((set) => ({
  deferredPrompt: null,
  isInstalled: false,
  setDeferredPrompt: (event) => set({ deferredPrompt: event }),
  // Once installed, there is no event to replay — Chrome never re-fires `beforeinstallprompt`
  // for an already-installed app.
  setInstalled: () => set({ isInstalled: true, deferredPrompt: null }),
  // A captured prompt can only be `.prompt()`-ed once — Chrome discards it after the user
  // chooses, even on "dismissed", so it must be dropped either way.
  clearDeferredPrompt: () => set({ deferredPrompt: null }),
}))
